import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage,
    showWarningMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject,
    showWarningMessage,
   API_URL,
};

export const GET_DIAGNOSISCODE = `${API_URL}/MasterICDs/GetMasterICDCodes`;
export const POST_DIAGNOSISCODE = `${API_URL}/MasterICDs/SaveMasterICDCodes`;
export const GET_DIAGNOSISCODE_BY_ID = `${API_URL}/MasterICDs/GetMasterICDCodesById`;
export const DELETE_DIAGNOSISCODE = `${API_URL}/MasterICDs/DeleteMasterICDCodes`;

export const DiagnosisActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'),
  get_diagnosis_codes: createRequestActionTypes('GET_DIAGNOSISCODE'),
  post_diagnosis_code: createRequestActionTypes('POST_DIAGNOSISCODE'),
  get_diagnosis_code_by_id: createRequestActionTypes('GET_DIAGNOSISCODE_BY_ID'),
  delete_diagnosis_code: createRequestActionTypes('DELETE_DIAGNOSISCODE'),
};

export const MODULE = 'MASTER_DIAGNOSIS';





// WEBPACK FOOTER //
// ./src/modules/Masters/components/diagnosisCode/constants/ApiConstants.js